export default "__VITE_ASSET__df7291fd__"